export default __webpack_public_path__ + "static/media/dripicons-v2.09c9c870.ttf";